import { render, staticRenderFns } from "./karzi_mo.vue?vue&type=template&id=c039e218&scoped=true&"
import script from "./karzi_mo.vue?vue&type=script&lang=js&"
export * from "./karzi_mo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c039e218",
  null
  
)

export default component.exports